exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.done[data-v-9cc39a56] {\n  background-color: #FFFFFF88;\n  cursor: initial !important;\n}\n.done[data-v-9cc39a56]:hover {\n  background-color: #FFFFFF88;\n}\n", ""]);

